module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataTransfer) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Comprovantes\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Comprovante " + _vm._s(_vm.dataTransfer.idTransfer) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-transfer-voucher",
    attrs: {
      "id": "comprovante"
    }
  }, [_c('div', {
    staticClass: "title-header-voucher"
  }, [_vm._v("Move Mais - Comprovante de Transferência de Créditos")]), _vm._v(" "), _c('div', {
    staticClass: "title-subheader-voucher"
  }, [_vm._v("de conta embarcador para conta embarcador")]), _vm._v(" "), _c('hr', {
    staticClass: "hrule-voucher"
  }), _vm._v(" "), _c('div', {
    staticClass: "subtitle-voucher"
  }, [_vm._v("\n          Dados da conta debitada\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-data-voucher"
  }, [_vm._v(_vm._s(_vm.dataTransfer.accountDebit.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-data-voucher"
  }, [_vm._v(_vm._s(_vm.dataTransfer.accountDebit.contract))])])]), _vm._v(" "), _c('hr', {
    staticClass: "hrule-voucher"
  }), _vm._v(" "), _c('div', {
    staticClass: "subtitle-voucher"
  }, [_vm._v("\n          Dados da conta creditada\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-data-voucher"
  }, [_vm._v(_vm._s(_vm.dataTransfer.accountCredit.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-data-voucher"
  }, [_vm._v(_vm._s(_vm.dataTransfer.accountCredit.contract))])])]), _vm._v(" "), _c('hr', {
    staticClass: "hrule-voucher"
  }), _vm._v(" "), _c('div', {
    staticClass: "subtitle-voucher"
  }, [_vm._v("\n          Valor\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "label-voucher-value"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.dataTransfer.value)))])])]), _vm._v(" "), _c('hr', {
    staticClass: "hrule-voucher"
  }), _vm._v(" "), _c('div', {
    staticClass: "label-voucher-date"
  }, [_vm._v("\n          " + _vm._s(_vm.getDateTransfer) + "\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "hrule-voucher"
  }), _vm._v(" "), _c('div', {
    staticClass: "label-voucher-code"
  }, [_vm._v("\n          " + _vm._s(_vm.dataTransfer.idTransfer) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-20"
  }, [_c('div', {
    staticClass: "back-button-box"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "tag": "button",
      "to": {
        name: 'transfer-shipper-vouchers'
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n          Voltar\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Imprimir comprovante"
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "icon-printer align-icon-left-white"
  }), _vm._v("\n          Imprimir\n        ")]), _vm._v(" "), _vm._m(4)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-voucher"
  }, [_vm._v("Nome da Empresa:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-voucher"
  }, [_vm._v("Nº do Contrato:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-voucher"
  }, [_vm._v("Nome da Empresa:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "label-voucher"
  }, [_vm._v("Nº do Contrato:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger add",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Baixar comprovante em PDF"
    }
  }, [_c('i', {
    staticClass: "icon-pdf align-icon-left-white"
  }), _vm._v("\n          Salvar PDF\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-50191b96!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/shipper/transfer-shipper-voucher-detail.vue
// module id = 2124
// module chunks = 1